module.exports = __webpack_public_path__ + "img/victorluis.3a9c2e8a.jpg";